/**
 * ⚠️ ARQUIVO TEMPORÁRIO — NÃO COMITAR.
 *
 * Os 17 ícones que `OutboundFlowPrototype` importa de `lucide-react`, desenhados
 * aqui em SVG inline. Existe para o protótipo rodar SEM instalar a dependência:
 * `package.json` e `pnpm-lock.yaml` são versionados, e adicionar pacote por
 * causa de um protótipo descartável deixaria rastro no repositório.
 *
 * Mesma API do lucide-react (`size`, `className`, resto das props repassado),
 * mesmo grid 24×24 e mesmo traço, então o protótipo renderiza sem alteração.
 * Se o fluxo for aprovado e virar feature, instale o lucide-react de verdade e
 * apague este arquivo.
 */

const Svg = ({ size = 24, children, ...rest }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        {...rest}
    >
        {children}
    </svg>
);

export const AlertTriangle = (props) => (
    <Svg {...props}>
        <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
        <path d="M12 9v4" />
        <path d="M12 17h.01" />
    </Svg>
);

export const Boxes = (props) => (
    <Svg {...props}>
        <path d="M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-4.5-2.6a2 2 0 0 0-2.06 0Z" />
        <path d="m7 16.5-4.74-2.85" />
        <path d="M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8A2 2 0 0 0 22 17.87v-3.24a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0L12 13.5Z" />
        <path d="M9.5 6.5 12 8l2.5-1.5" />
        <path d="M12 2 8.5 4v4L12 10l3.5-2V4Z" />
    </Svg>
);

export const Camera = (props) => (
    <Svg {...props}>
        <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
        <circle cx="12" cy="13" r="3" />
    </Svg>
);

export const Check = (props) => (
    <Svg {...props}>
        <path d="M20 6 9 17l-5-5" />
    </Svg>
);

export const ChevronRight = (props) => (
    <Svg {...props}>
        <path d="m9 18 6-6-6-6" />
    </Svg>
);

export const FileText = (props) => (
    <Svg {...props}>
        <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z" />
        <path d="M14 2v5h5" />
        <path d="M16 13H8" />
        <path d="M16 17H8" />
        <path d="M10 9H8" />
    </Svg>
);

export const HelpCircle = (props) => (
    <Svg {...props}>
        <circle cx="12" cy="12" r="10" />
        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
        <path d="M12 17h.01" />
    </Svg>
);

export const Layers = (props) => (
    <Svg {...props}>
        <path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z" />
        <path d="m6.08 9.5-3.48 1.59a1 1 0 0 0 0 1.81l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9a1 1 0 0 0 0-1.83L17.92 9.5" />
        <path d="m6.08 14.5-3.48 1.59a1 1 0 0 0 0 1.81l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9a1 1 0 0 0 0-1.83l-3.51-1.6" />
    </Svg>
);

export const Monitor = (props) => (
    <Svg {...props}>
        <rect width="20" height="14" x="2" y="3" rx="2" />
        <path d="M8 21h8" />
        <path d="M12 17v4" />
    </Svg>
);

export const Package = (props) => (
    <Svg {...props}>
        <path d="m7.5 4.27 9 5.15" />
        <path d="M21 8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16Z" />
        <path d="m3.3 7 8.7 5 8.7-5" />
        <path d="M12 22V12" />
    </Svg>
);

export const Printer = (props) => (
    <Svg {...props}>
        <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
        <path d="M6 9V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v6" />
        <rect width="12" height="8" x="6" y="14" rx="1" />
    </Svg>
);

export const RotateCcw = (props) => (
    <Svg {...props}>
        <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
        <path d="M3 3v5h5" />
    </Svg>
);

export const ScanLine = (props) => (
    <Svg {...props}>
        <path d="M3 7V5a2 2 0 0 1 2-2h2" />
        <path d="M17 3h2a2 2 0 0 1 2 2v2" />
        <path d="M21 17v2a2 2 0 0 1-2 2h-2" />
        <path d="M7 21H5a2 2 0 0 1-2-2v-2" />
        <path d="M7 12h10" />
    </Svg>
);

export const Smartphone = (props) => (
    <Svg {...props}>
        <rect width="14" height="20" x="5" y="2" rx="2" />
        <path d="M12 18h.01" />
    </Svg>
);

export const Truck = (props) => (
    <Svg {...props}>
        <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
        <path d="M15 18H9" />
        <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.62l-3.48-4.35A1 1 0 0 0 17.52 8H14" />
        <circle cx="17" cy="18" r="2" />
        <circle cx="7" cy="18" r="2" />
    </Svg>
);

export const Upload = (props) => (
    <Svg {...props}>
        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
        <path d="m17 8-5-5-5 5" />
        <path d="M12 3v12" />
    </Svg>
);

export const X = (props) => (
    <Svg {...props}>
        <path d="M18 6 6 18" />
        <path d="m6 6 12 12" />
    </Svg>
);
